import { Component, OnInit } from '@angular/core';

 import {session} from '../../../../environments/environment.session'
  @Component({
  selector: '[app-portal-footer]',
  templateUrl: './portal-footer.component.html',
  styleUrls: ['./portal-footer.component.css']
})
export class PortalFooterComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
